import LoadView from "../loadview";
import InitVue from "./initvue";

export default {
  /**
   * @param {{linkSelector: string, elements: HTMLCollectionOf<Element>, eventId: string}[]} spaLinkGroups 
   * @param {string} navigatedText 
   */
  startObserve: function (spaLinkGroups, navigatedText) {
    // Observe attribute on body for changes so that we can reinitiate script
    // components when the contents is loaded through any SPA-links.
    const body = document.querySelector("body");
    const config = {
      attributes: true,
      attributeFilter: ["data-observe-update"],
      childList: false,
      subtree: false,
    };

    // Callback function to execute when mutations are observed
    const callback = function (mutationsList, observer) {
      // Use traditional 'for loops' for IE 11
      for (const mutation of mutationsList) {
        if (mutation.type === "attributes") {
          ObservedVuecomponentSelectors.forEach(selector=>{
            observeComponent(selector);
          });

          ObservedScripts.forEach(script=>{
            observeScript(script.initFunc, script.selector);
          });
          
          initSpaLinkGroups(spaLinkGroups, navigatedText);
        }
      }
    };

    // Create an observer instance linked to the callback function
    const observer = new MutationObserver(callback);

    // Start observing the target node for configured mutations
    observer.observe(body, config);

    initSpaLinkGroups(spaLinkGroups, navigatedText);
  }, 

  /**
   * @param {{container: string, doNotObserve: boolean}[]} vuecomponentList 
   */
  setObservedVuecomponents: function (vuecomponentList) {
    ObservedVuecomponentSelectors = [];
    vuecomponentList.forEach(vuecomponentData=>{
      if(!vuecomponentData.doNotObserve) {
        ObservedVuecomponentSelectors.push(vuecomponentData.container);
      }
    });
  },

  /**
   * @param {{initFunc: ()=>void, observeSelector: string}[]} scriptList 
   */
  setObservedScripts: function (scriptList) {
    ObservedScripts = [];
    scriptList.forEach(scriptData=>{
      if(scriptData.observeSelector) {
        ObservedScripts.push({initFunc: scriptData.initFunc, selector: scriptData.observeSelector});
      }
    });
  }, 
};

/**
 * @type {string[]}
 */
var ObservedVuecomponentSelectors = [];
/**
 * @type {{initFunc: ()=>void, observeSelector: string}[]}
 */
var ObservedScripts = [];

/**
 * @param {string} selector 
 */
function observeComponent(selector) {
  if(selector[0]=='.') {
    observeComponentByClass(selector);
  }

  if(selector[0]=='#') {
    observeComponentById(selector);
  }
}

/**
 * @param {string} className 
 */
function observeComponentByClass(className) {
  let components = document.querySelectorAll(className);
  if (components.length) {
    var oinitierad = 0;
    components.forEach((comp) => {
      if (!comp.hasAttribute("data-v-app")) {
        InitVue.deleteOldComponent(className.substring(1));
        oinitierad++;
      }
    });

    if (oinitierad > 0) {
      InitVue.initComponent(className);
    }
  }
}

/**
 * @param {string} id 
 */
function observeComponentById(id) {
  let component = document.getElementById(id.substring(1));
  if (component && !component.hasAttribute("data-v-app")) {
    InitVue.deleteOldComponent(id);
    InitVue.initComponent(id);
  }
}

/**
 * @param {()=>void} initFunc 
 * @param {string} selector 
 */
function observeScript(initFunc, selector) {
  let scriptElements = document.querySelectorAll(selector);
  if (scriptElements.length) {
    initFunc();
  }
}

/**
 * @param {{linkSelector: string, elements: HTMLCollectionOf<Element>, eventId: string}[]} spaLinkGroups 
 * @param {string} navigatedText 
 */
function initSpaLinkGroups(spaLinkGroups, navigatedText) {
  if(spaLinkGroups && navigatedText) {
    spaLinkGroups.forEach(linkGroup=>{
      if(linkGroup.elements?.length ?? false) {
        LoadView.addReplacePageClickEventToElements(linkGroup.elements, navigatedText, linkGroup.eventId);
      }
      if(linkGroup.linkSelector?.length ?? false) {
        var elements = document.querySelectorAll(linkGroup.linkSelector) ?? [];
        LoadView.addReplacePageClickEventToElements(elements, navigatedText, linkGroup.eventId);
      }
    });

    window.onpopstate = function(){
      LoadView.getAndReplacePage(window.location.href, navigatedText, false);
    }
  }
}